import { render, staticRenderFns } from "./dismiss-action.vue?vue&type=template&id=f01070b0&scoped=true"
import script from "./dismiss-action.vue?vue&type=script&lang=js"
export * from "./dismiss-action.vue?vue&type=script&lang=js"
import style0 from "./dismiss-action.vue?vue&type=style&index=0&id=f01070b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f01070b0",
  null
  
)

export default component.exports